var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "box view-nav-bar" }, [
      _c("div", { staticClass: "d-flex align-items-center w-100" }, [
        _c(
          "div",
          { staticClass: "flex-grow-1" },
          [
            _c(
              "router-link",
              {
                staticClass: "mr-3",
                attrs: { to: "/history/" + _vm.movixId + "/month" },
              },
              [
                _c("icon", { attrs: { name: "chevron-left" } }),
                _vm._v(" Per Month\n                "),
              ],
              1
            ),
            _vm._v(" "),
            _c("strong", [_vm._v(_vm._s(_vm.movieTitle))]),
            _vm._v(" "),
            _c("span", { staticClass: "text-muted ml-2" }, [
              _vm._v("— " + _vm._s(_vm.month) + " — " + _vm._s(_vm.modeLabel)),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-sm mr-2",
                class:
                  _vm.mode === "day" ? "btn-primary" : "btn-outline-secondary",
                attrs: {
                  to:
                    "/history/" + _vm.movixId + "/month/" + _vm.month + "/day",
                },
              },
              [_vm._v("\n                    Per Day\n                ")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "btn btn-sm",
                class:
                  _vm.mode === "site" ? "btn-primary" : "btn-outline-secondary",
                attrs: {
                  to:
                    "/history/" + _vm.movixId + "/month/" + _vm.month + "/site",
                },
              },
              [_vm._v("\n                    Per Cinema\n                ")]
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "box-content text-center text-muted py-4" },
            [_vm._v("Loading…")]
          ),
        ])
      : !_vm.rows.length
      ? _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "box-content text-center text-muted py-4" },
            [_vm._v("No admissions data found.")]
          ),
        ])
      : _c("div", { staticClass: "box" }, [
          _c("div", { staticClass: "box-content" }, [
            _c("table", { staticClass: "shx-table w-100 mt-2" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", { staticClass: "shx-th-150" }, [
                    _vm._v(_vm._s(_vm.columnLabel)),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "shx-th-120 text-right" }, [
                    _vm._v("Admissions"),
                  ]),
                  _vm._v(" "),
                  _c("th"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.rows, function (row) {
                  return _c("tr", { key: _vm.rowKey(row) }, [
                    _c("td", [_vm._v(_vm._s(_vm.rowLabel(row)))]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(_vm._s(_vm.formatInt(row.admissions))),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("div", {
                        staticClass: "bg-secondary",
                        style: {
                          width: _vm.barWidth(row.admissions),
                          height: "8px",
                        },
                      }),
                    ]),
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("tfoot", [
                _c("tr", [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.formatInt(_vm.totalAdmissions))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td"),
                ]),
              ]),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Total")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }